import React from 'react';
import { motion } from 'framer-motion';
import body_lotion75 from '../images/products/THERADERM PRODUCTS FINAL RENDER/BODY LOTION 75ML.png';
import body_lotion200 from '../images/products/THERADERM PRODUCTS FINAL RENDER/BODY LOTION 200ML.png';
import body_lotion500 from '../images/products/THERADERM PRODUCTS FINAL RENDER/BODY LOTION 500ML.png';
import bodlo from '../images/prod_ngs/TheraDermBackgroundPictures-06.png';

function BodyLotion() {
  return (
    <div>
      {/* Header Section */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="py-12 text-center"
      >
        <h1 className="text-2xl md:text-4xl font-bold text-white mb-2 font-serif">
          BODY LOTION
        </h1>
        <div className="w-48 h-1 bg-amber-500 mx-auto mb-4"></div>
        <p className="text-amber-300 text-lg md:text-xl uppercase tracking-wider">
          With Sweet Almond Oil
        </p>
      </motion.div>

      {/* Product Section */}
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.8 }}
        className="relative overflow-hidden my-8 mx-auto max-w-6xl rounded-xl shadow-lg border-l-4 border-amber-500"
        style={{
          backgroundImage: `url(${bodlo})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="absolute inset-0 bg-black/30"></div>

        <div className="grid grid-cols-1 lg:grid-cols-2 relative z-10">

          {/* IMAGE GALLERY — LEFT */}
          <div className="flex flex-col items-center justify-center p-6 lg:p-8 order-1">
            <div className="flex items-end justify-center space-x-4 md:space-x-6">
              <motion.div whileHover={{ scale: 1.03 }} className="transition-all duration-300">
                <img
                  src={body_lotion75}
                  alt="Body Lotion 75ml"
                  className="w-16 md:w-20 lg:w-24 h-auto object-contain drop-shadow-lg"
                />
              </motion.div>

              <motion.div whileHover={{ scale: 1.03 }} className="transition-all duration-300">
                <img
                  src={body_lotion200}
                  alt="Body Lotion 200ml"
                  className="w-20 md:w-24 lg:w-28 h-auto object-contain drop-shadow-lg"
                />
              </motion.div>

              <motion.div whileHover={{ scale: 1.03 }} className="transition-all duration-300">
                <img
                  src={body_lotion500}
                  alt="Body Lotion 500ml"
                  className="w-24 md:w-28 lg:w-32 h-auto object-contain drop-shadow-lg"
                />
              </motion.div>
            </div>

            <p className="text-white text-sm bg-black/30 px-3 py-1 rounded-full mt-4">
              Available in <span className="text-amber-300">75ml</span>,{' '}
              <span className="text-amber-300">200ml</span> &{' '}
              <span className="text-amber-300">500ml</span>
            </p>
          </div>

          {/* PRODUCT INFO — RIGHT */}
          <div className="flex flex-col justify-center p-6 lg:p-8 text-white order-2">
            <motion.h2
              initial={{ x: 20, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              className="text-2xl md:text-3xl font-bold mb-4 text-center lg:text-right"
            >
              Nourishing Body Lotion
            </motion.h2>

            <motion.p
              initial={{ x: 20, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.3 }}
              className="text-white/90 mb-6 text-center lg:text-right text-sm md:text-base"
            >
              <span className="text-amber-300 font-semibold">THERA DERM's Body Lotion</span> is a non-greasy,
              lightweight moisturizer enriched with Xylitol and Vitamin E. Perfect for dry and normal skin,
              helping maintain moisture and protecting against external aggressors.
            </motion.p>

            <motion.div
              initial={{ x: 20, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.4 }}
              className="text-center lg:text-right italic text-lg font-serif"
            >
              "For <span className="text-amber-300">nourished</span> &{' '}
              <span className="text-amber-300">radiant</span> skin"
            </motion.div>
          </div>

        </div>
      </motion.div>
    </div>
  );
}

export default BodyLotion;
